<template>
  <!-- 待办任务 -->
  <div style="position: relative;">
    <el-form ref="formMyTask" :model="formMyTask" label-width="100px" :size="defaultFormItemSize" label-position="right"
      @submit.native.prevent>
      <filter-box :item-width="350">
        <el-form-item label="申请单号" prop="formFilter.processDefinitionName">
          <el-input class="filter-item" v-model="formMyTask.formFilter.processDefinitionName" :clearable="true"
            placeholder="申请单号" />
        </el-form-item>
        <!--<el-form-item label="流程标识" prop="formFilter.processDefinitionKey">-->
        <!--<el-input class="filter-item" v-model="formMyTask.formFilter.processDefinitionKey"-->
        <!--:clearable="true" placeholder="流程标识" />-->
        <!--</el-form-item>-->
        <el-form-item label="当前任务" prop="formFilter.taskName">
          <el-input class="filter-item" v-model="formMyTask.formFilter.taskName" :clearable="true" placeholder="当前任务" />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize"
          @click="onReset">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize"
          @click="refreshMyTask(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="flowEntry" :header-cell-style="{ background: '#FAFAFA', color: '#606266' }"
          :data="formMyTask.taskWidget.dataList" :size="defaultFormItemSize"
          @sort-change="formMyTask.taskWidget.onSortChange" header-cell-class-name="table-header-gray">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
            :index="formMyTask.taskWidget.getTableIndex" />
          <el-table-column label="流程名称" prop="processDefinitionName" />
          <el-table-column label="申请单号" prop="processInstanceName" />
          <el-table-column label="当前任务" prop="taskName" />
          <el-table-column label="任务发起人" prop="processInstanceInitiatorName" />
          <el-table-column label="任务发起时间" prop="processInstanceStartTime" />
          <el-table-column label="计划完成时间" prop="processInstanceDueTime" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button class="table-btn primary" :size="defaultFormItemSize" type="text"
                @click="onSubmit(scope.row)">办理</el-button>
              <el-button class="table-btn primary" :size="defaultFormItemSize" type="text"
                @click="onTransferTo(scope.row)">转办</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination :total="formMyTask.taskWidget.totalCount" :current-page="formMyTask.taskWidget.currentPage"
            :page-size="formMyTask.taskWidget.pageSize" :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes" @current-change="formMyTask.taskWidget.onCurrentPageChange"
            @size-change="formMyTask.taskWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { FlowDictionaryController, FlowOperationController } from '@/api/flowController.js';
import TaskTransferTo from '@/views/workflow/components/TaskTransferTo.vue';
export default {
  name: 'formMyTask',
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data() {
    return {
      formMyTask: {
        formFilter: {
          processDefinitionName: undefined,
          processDefinitionKey: undefined,
          taskName: undefined
        },
        formFilterCopy: {
          processDefinitionName: undefined,
          processDefinitionKey: undefined,
          taskName: undefined
        },
        taskWidget: new TableWidget(this.loadTaskData, this.loadTaskDataVerify, true, false, 'entryId', 1),
        isInit: false,
      },
      paramsE: undefined,
    }
  },
  methods: {
    onReset() {
      this.$refs.formMyTask.resetFields();
      this.refreshMyTask(true);
    },
    loadTaskData(params) {
      if (params == null) params = {};
      params = {
        processDefinitionName: this.formMyTask.formFilterCopy.processDefinitionName,
        processDefinitionKey: this.formMyTask.formFilterCopy.processDefinitionKey,
        taskName: this.formMyTask.formFilterCopy.taskName,
        ...params
      }
      this.paramsE = params;
      return new Promise((resolve, reject) => {
        FlowOperationController.listRuntimeTask(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadTaskDataVerify() {
      this.formMyTask.formFilterCopy.processDefinitionName = this.formMyTask.formFilter.processDefinitionName;
      this.formMyTask.formFilterCopy.processDefinitionKey = this.formMyTask.formFilter.processDefinitionKey;
      this.formMyTask.formFilterCopy.taskName = this.formMyTask.formFilter.taskName;
      return true;
    },
    onSelectAssignee(row) {
      this.$dialog.show('选择用户', TaskTransferTo, {
        area: ['450px', '280px']
      }).then(res => {
        var params = {};
        params['processInstanceId'] = row['processInstanceId'];
        params['taskId'] = row['taskId'];
        params['comment'] = res['message'];
        params['delegateAssignee'] = res['assignee'];
        console.log(res);
        FlowOperationController.interveneRuntimeTask(this, params).then(res => {
          if (res.success) {
            this.$message.success('操作成功！');
            this.refreshMyTask();
          }
        }).catch(e => { });
      }).catch(e => { });
    },
    onTransferTo(row) {
      //转办
      this.onSelectAssignee(row);
    },
    onSubmit(row) {
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: row.taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              taskId: row.taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: row.taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              processInstanceInitiatorName: row.processInstanceInitiatorName,
              // 过滤掉加签操作，加签只有在已完成任务里可以操作
              operationList: (res.data.operationList || []),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => { });
    },
    refreshMyTask(reloadData = false) {
      if (reloadData) {
        this.formMyTask.taskWidget.refreshTable(true, 1);
      } else {
        this.formMyTask.taskWidget.refreshTable();
      }
    },
    onResume() {
      this.refreshMyTask();
    },
    formInit() {
      this.refreshMyTask();
    },
    onExport() {
      var exportColumnList = [];
      this.formConfig.formQueryTable.tableColumnList.forEach((item) => {
        var exportColumn = new Object();
        exportColumn['tableId'] = item['tableId'];
        exportColumn['columnId'] = item['columnId'];
        exportColumn['showName'] = item['showName'];
        exportColumn['showOrder'] = item['showOrder'];
        exportColumnList.push(exportColumn);
      });

      var operation = new Object();
      operation['id'] = 0;
      operation['type'] = 3;
      operation['name'] = '导出';
      operation['enabled'] = true;
      operation['builtin'] = true;
      operation['rowOperation'] = false;
      operation['btnType'] = 'primary';
      operation['plain'] = true;
      operation['exportColumnList'] = exportColumnList;

      var params = {
        ...this.paramsE,
        exportInfoList: exportColumnList,
        flowWorkOrderDtoFilter: {
          flowStatus: this.formFilter.flowStatus,
          processInstanceName: this.formFilter.processInstanceName,
          createTimeStart: Array.isArray(this.formFilter.createTime) ? this.formFilter.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.formFilter.createTime) ? this.formFilter.createTime[1] : undefined,
        },
        keyword: this.keyword
      }
      this.$refs[this.formConfig.formQueryTable.variableName].flowExport(params, this.processDefinitionKey);

    },
  },
  mounted() {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style></style>
